import { createAction, props } from '@ngrx/store';
import { UserProfile } from '../reducers/session-profile.reducer';

export enum SessionProfileActions {
  ProfileFetched = '[Session/Profile] Profile fetched',
  ProfileUpdated = '[Session/Profile] Profile updated',
}

export const userProfileFetched = createAction(
  SessionProfileActions.ProfileFetched,
  props<{
    userProfile: UserProfile;
  }>(),
);

export const userProfileUpdated = createAction(
  SessionProfileActions.ProfileUpdated,
  props<{
    userProfile: UserProfile;
  }>(),
);
